module.exports = __webpack_public_path__ + "img/1696381219191-09f264a2-9c58-48e2-bc74-cd147481ffe8.jpeg.86bacd76.webp";